<template>
    <div class="mx-2 mx-lg-5">
        <VehicleEntryFormWrapper
            :vehicle="vehicleCopy"
            :commodities="commoditiesCopy"
            ref="entryForm"
        />

        <div class="my-4">
            <button class="btn btn-primary w-100 py-3 fw-bold fs-5" @click="submitForm">{{ $t("utils.save") }}</button>
        </div>
    </div>
</template>

<script>
    import VehicleEntryFormWrapper from '@/components/VehicleEntryFormWrapper.vue';
    import Icon from '@/components/Icon.vue'

    export default {
        components: {
            VehicleEntryFormWrapper,
            Icon,
        },
        data() {
            return {
                commodities: [
                    {id: 1}
                ],
                nextCommodityId: 2,
                vehicle: [],
                vehicleCopy: {},
                commoditiesCopy: [],
            }
        },
        created() {
            const copy = this.$store.getters.getCopyRecord;

            if (copy) {
                this.vehicleCopy = copy.vehicle || {};
                this.commoditiesCopy = copy.commodities || [];
                this.$store.commit("clearCopyRecord")
            }
        },
        methods: {
            submitForm() {
                const result = this.$refs.entryForm.collectFormData();
                if (!result) return;

                const { vehicle, commodities } = result;
                const formData = {
                    ...vehicle,
                    commodities
                };

                this.$store.getters.api.post(`/${this.$route.params.slug}/vehicle-entries/add`, formData)
                .then(response => {
                    this.$router.push({
                        name: "vehicleEntryDetailView",
                        params: {
                            slug: this.$route.params.slug,
                            id: response.data.vehicle.id
                        }
                    });
                })
                .catch(error => {
                    console.error("Error adding vehicle entry", error);
                });
            }
        }
    }
</script>